import {Pipe, PipeTransform} from "@angular/core";
import {DoctorDataModel} from "../../../models/doctors/doctor-data.model";

@Pipe({
  name: 'ProviderReferringDoctorPipe'
})

export class ProviderReferringDoctorPipe implements PipeTransform {

  transform(doctors: DoctorDataModel[], DoctorId: string): any {
    if (!doctors || !DoctorId) {
      return null;
    }
    return doctors.filter(doctor => doctor.DoctorId === DoctorId);
  }

}
